import axios from 'axios';
import { API_URL } from './utils';

/**
 * Fetch companies by an arbitrary number of ids without exploding the URL.
 *
 * The /companies/lookup endpoint accepts a comma-separated `ids` query param.
 * With thousands of company ids the URL exceeds proxy limits (~8KB),
 * causing 414 errors. This helper batches the ids and merges the results.
 *
 * @param {string[]} ids - list of company ids (may be empty/large)
 * @param {number} [chunkSize=100] - ids per request
 * @returns {Promise<Array<{id: string, name: string, category?: string}>>}
 */
export async function fetchCompaniesByIds(ids, chunkSize = 100) {
  const unique = Array.from(new Set((ids || []).filter(Boolean)));
  if (unique.length === 0) return [];
  const chunks = [];
  for (let i = 0; i < unique.length; i += chunkSize) {
    chunks.push(unique.slice(i, i + chunkSize));
  }
  const results = await Promise.all(
    chunks.map((chunk) =>
      axios
        .get(`${API_URL}/companies/lookup`, { params: { ids: chunk.join(',') } })
        .then((r) => r.data?.items || [])
        .catch((err) => {
          console.error('companies/lookup chunk failed:', err);
          return [];
        })
    )
  );
  const seen = new Set();
  const out = [];
  for (const list of results) {
    for (const c of list) {
      if (c?.id && !seen.has(c.id)) {
        seen.add(c.id);
        out.push(c);
      }
    }
  }
  return out;
}
